module.exports = __webpack_public_path__ + "static/mutter-03-863334bc661ddc2c462a14b0d8b6f9dc.jpg";